// bussinessReviews.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { bussinessReviews } = Dictionary

const bussinessReviewsServies = {
  view: async (id, paramsObj) => {
    return axios.get(baseURL + bussinessReviews.listDetail(id), { params: paramsObj })
  }, 
  getLocation: async (id, paramsObj) => {
    return axios.get(baseURL + bussinessReviews.getLocation(id), { params: paramsObj })
  },
  add: async (data) => {
    return axios.post(baseURL + bussinessReviews.create(), data)
  },
  delete: async (id) => {
    return axios.delete(baseURL + bussinessReviews.getById(id))
  },
  edit: async (id, data) => {
    return axios.put(baseURL + bussinessReviews.getById(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(baseURL + bussinessReviews.getById(id))
  },
  ratingDetail: async (id,paramsObj) => {
    return axios.get(baseURL + bussinessReviews.ratingDetail(id), { params: paramsObj })
  },
  reviewTagBar: async (id,paramsObj) => {
    return axios.get(baseURL + bussinessReviews.reviewTagBar(id), { params: paramsObj })
  },
}
export default bussinessReviewsServies